<div class="header-container">
    <div id="bloc1" class="block1" >
        <span >
            <mat-icon class="s-icon"> supervisor_account </mat-icon>
        </span>
        <span class="hide-text-lebel">
            Board Members
        </span>
        
    </div>
    <div id="bloc2" class="block2">
        <input class="search-bar" 
        type="search" 
        aria-label="search" 
        placeholder="Search" 
        [(ngModel)]="searchText"  
        (ngModelChange)="onSearch($event)">
    </div>
    <div id="bloc3" class="block3">
        <span class="full-text">
            <button (click)= "openDialog()" mat-raised-button>Add Board Member</button>
        </span>
        <span class="short-text">
            <button (click)= "openDialog()" mat-raised-button>Add</button>
        </span>
    </div>
</div>
<mat-spinner style="margin: auto;" *ngIf="showSpinner" ></mat-spinner>

<div class="mat-elevation-z8" style="padding: 2vw;" [hidden]="showSpinner">
    <table mat-table [dataSource]="dataSource" matSort>
    
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let row"> {{row.name | titlecase}} </td>
        </ng-container>

        <ng-container matColumnDef="division">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Division </th>
            <td mat-cell *matCellDef="let row" > {{row.division}} </td>
        </ng-container>

        <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Contact </th>
            <td mat-cell *matCellDef="let row" > {{row.phone}} </td>
        </ng-container>
    
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef> Polls </th>
            <td mat-cell *matCellDef="let row" > <mat-icon >equalizer</mat-icon> </td>
        </ng-container>
    
        <ng-container matColumnDef="created_at" >
            <th mat-header-cell *matHeaderCellDef> Delete </th>
            <td mat-cell *matCellDef="let row"> <mat-icon (click)="deleteBoardMember(row)">delete</mat-icon> </td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">No data matching the filter "{{searchText}}"</td>
        </tr>
    </table>
    
    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
</div>



